import { call, put } from 'redux-saga/effects';
import { formatMessage } from 'devextreme/localization';
import * as action from '../actions/adminMessages';
import { get, post } from '../../utils/api';
import { modalErrorOpen } from '../actions/modalError';

export function* getMessagesFilter({ payload }) {
  try {
    const response = yield call(
      get,
      '/admin/messages/direction_filter'
    );
    yield put(action.getMessagesFilterSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.getMessagesFilterFail());
  }
}

export function* getMessages({ payload }) {
  try {
    const msgType = payload.type && payload.type !== 'N' ? `&msgTypeCode=${payload.type}` : '';
    const response = yield call(
      post,
      `/admin/messages/find?direction=${payload.direction}${msgType}`,
      payload.filter
    );

    yield put(action.getMessagesSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.getMessagesFail());
  }
}

export function* getMessageTypeFilter({ payload }) {
  try {
    const response = yield call(
      get,
      `/admin/messages/msg_type_filter?direction=${payload}`
    );

    yield put(action.getMessageTypeFilterSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.getMessageTypeFilterFail());
  }
}

export function* resetMessages({ payload }) {
  try {
    const response = yield call(
      post,
      `/admin/messages/${payload.type || 'MET_SAP'}/reset?msgCounter=${
        payload.msgCounter
      }`
    );
    yield put(action.resetMessagesSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.resetMessagesFail());
  }
}

export function* getMessageXml({ payload }) {
  try {
    const response = yield call(
      get,
      `/admin/messages/find/${payload.type}/xml?msgCounter=${payload.msgCounter}`
    );
    yield put(action.getMessageXmlSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.getMessageXmlFail());
  }
}
